import {ActionList, ActionMenu, Box, Button, Link, Portal, Text} from '@primer/react'
import {Dialog} from '@primer/react/experimental'

export type ReportContentDialogProps = {
  owner: string
  ownerUrl: string
  reportUrl: string
  onClose: () => void
}

export const ReportContentDialog = ({owner, ownerUrl, reportUrl, onClose}: ReportContentDialogProps) => {
  return (
    <Portal>
      <Dialog
        renderHeader={() => (
          <Dialog.Header>
            <Box sx={{display: 'flex'}}>
              <Box sx={{display: 'flex', flexDirection: 'column', flexGrow: 1, px: 2, py: '6px'}}>
                <Dialog.Title>Report content</Dialog.Title>
              </Box>
              <Dialog.CloseButton onClose={onClose} />
            </Box>
          </Dialog.Header>
        )}
        sx={{
          width: '100%',
          margin: 4,
          maxWidth: '640px',
          maxHeight: 'clamp(315px, 80vh, 800px)',
        }}
        width="xlarge"
        height="auto"
        onClose={onClose}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <Box
            sx={{
              width: '55%',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Box>
              <Text>This content violates </Text>
              <Link href={ownerUrl}>{`@${owner}'s `}</Link>
              <Text>
                Code of Conduct and should be submitted to the maintainers of this repository for review.
                <br />
                <br />
                This report, as well as your username as the reporter, will be viewable by all admins of this
                repository.
                <br />
                <br />
                Choose a reason for reporting this content
              </Text>
            </Box>
            <Box
              sx={{
                marginTop: '8px',
                marginBottom: '16px',
              }}
            >
              <ActionMenu>
                <ActionMenu.Button>Choose a reason</ActionMenu.Button>

                <ActionMenu.Overlay>
                  <ActionList>
                    <ActionList.Item>Abuse</ActionList.Item>
                    <ActionList.Item>Spam</ActionList.Item>
                    <ActionList.Item>Off Topic</ActionList.Item>
                  </ActionList>
                </ActionMenu.Overlay>
              </ActionMenu>
            </Box>
            <Box
              sx={{
                marginTop: 'auto',
              }}
            >
              <Box
                sx={{
                  fontSize: '12px',
                  color: 'fg.muted',
                }}
              >
                <Text>Learn more about </Text>
                <Link href="https://docs.github.com/en/articles/reporting-abuse-or-spam">
                  requesting that maintainers moderate content.
                </Link>
              </Box>
              <Button
                sx={{
                  marginTop: '10px',
                  width: '100%',
                }}
                variant={'danger'}
              >
                Report to repository admins
              </Button>
            </Box>
          </Box>
          <Box
            sx={{
              width: '40%',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Text>Contact GitHub Support about this user&apos;s spammy or abusive behavior.</Text>
            <Box
              sx={{
                marginTop: 'auto',
              }}
            >
              <Box
                sx={{
                  marginTop: 'auto',
                  fontSize: '12px',
                  color: 'fg.muted',
                }}
              >
                <Text>Learn more about </Text>
                <Link href="https://docs.github.com/en/articles/reporting-abuse-or-spam">
                  reporting abuse to GitHub support
                </Link>
              </Box>
              <Button
                sx={{
                  width: '100%',
                  marginTop: '10px',
                }}
                variant={'danger'}
                as={'a'}
                href={reportUrl}
              >
                Report abuse to GitHub support
              </Button>
            </Box>
          </Box>
        </Box>
      </Dialog>
    </Portal>
  )
}

try{ ReportContentDialog.displayName ||= 'ReportContentDialog' } catch {}